const KEY_accessToken = 'gowow_accessToken'

export const setAccessToken = (value) => {
    localStorage.setItem(KEY_accessToken, value)
}

export const getAccessToken = () => {
    return localStorage.getItem(KEY_accessToken)
}